import { AppRoutingService } from '@core/app-routing.service';
import { NavigationMenuItem } from '@models/navigation-menu-item';
import { BehaviorSubject } from 'rxjs';

export enum ReportsSubNavMenuId {
  StudentActivityReports = 'reports-subnav-student-activity-reports',
  ProgressReports = 'reports-subnav-progress-reports',
}

export function buildReportsSubnav(
  appRoutingService: AppRoutingService,
  subNavMenuItems: BehaviorSubject<NavigationMenuItem[]>,
  hasProgressReports: boolean,
  studentActivityReportActive: boolean,
): void {
  const newMenus: NavigationMenuItem[] = [];

  newMenus.push(
    {
      id: ReportsSubNavMenuId.StudentActivityReports,
      weight: 0,
      route: appRoutingService.getTeachersStudentActivityReportsRoute().toString(),
      label: 'Student Activity Reports',
      ariaLabel: studentActivityReportActive ? 'Current Page, Student Activity Reports' : '',
    },
  );

  if (hasProgressReports) {
    newMenus.push(
      {
        id: ReportsSubNavMenuId.ProgressReports,
        weight: 1,
        route: appRoutingService.getTeachersProgressReportsRoute().toString(),
        label: 'Progress Reports',
        ariaLabel: studentActivityReportActive ? '' : 'Current Page, Progress Reports',
      },
    );
  }

  subNavMenuItems.next(newMenus);
}
